<template>
   <div>

         <div class="tdsframe">
        
        <!-- <div class="tdshead">
            <div style="margin-left:32px">
                请选择您关注的目标疾病
            </div>
        </div> -->

          
        <div class="tdstree">

       <el-table
        
      :data="tdsdata.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
    style="width: 100%" ref="refTable" :header-cell-style="{'text-align': 'center'}" >
    <el-table-column
      width="40%"  >
       <template slot-scope="scope" >
       <el-checkbox v-model="selectedpkgs[scope.row.PKID]"  @change="CountPrice(scope.row.PKID)" :checked="displayChecked(scope.row.PKID)" :disabled="disabledChecked(scope.row.PKID)" >
       </el-checkbox>
       </template>
    </el-table-column>
    
<!--   <el-table-column
      label="序号"  width="40"
       type="index">
    </el-table-column> -->
    <el-table-column
      label="目标疾病" 
       width="80%" 
      prop="name" >
    </el-table-column>

    <el-table-column
      label="包含项目"  
      >
     <template slot-scope="props">
         <span v-for=" (item,i) in props.row.gids"  :label="item.label"
                                    :value="item.value"
                                    :key="item.value">
                                    
    <span  v-if="i===props.row.gids.length-1">   {{getG(item).GNAME }}</span>
      <span  v-if="i!=props.row.gids.length-1">   {{getG(item).GNAME+' ,' }}</span> 
                   
        </span>
     </template>
      
       
     
    </el-table-column>
     <el-table-column
      label="价格(元)"
        width="60%"
      prop="price">
    </el-table-column>
        
      </el-table>
      
               <div style="text-align:center;padding-bottom:66px;">
            
           
        </div>
        </div>
          <div id="content"  class="contentDown">
          
            
             <el-row style=" top:50%;">
              <el-col :span="14">应收金额:{{Math.max(Number(this.lZheKouPrice+this.monoidalprice) - Number(this.user.FixedQuota)+Number(this.user.FuWuFei),0).toFixed(2)}}元</el-col>
            
              <el-col :span="10"> <el-button type="primary"  @click="nextstep" :disabled="!hasselected()" style="width: 100%;">下一步</el-button></el-col>
                
     <!--   <el-col :span="4">折后价格:</el-col>
        <el-col :span="8">{{Math.max(Number(this.lZheKouPrice+this.monoidalprice),0).toFixed(2)}}元</el-col>
        <el-col :span="4">服务费:</el-col>
         <el-col :span="8">{{this.user.FuWuFei}}元</el-col>
           <el-col :span="4">额定金额:</el-col>
            <el-col :span="8">{{parseFloat(this.user.FixedQuota).toFixed(2)}}元</el-col> -->
               
             </el-row>
         

         </div>
        
        </div>
   
   </div>
</template>

<script>
    import {restbase} from '../rest'
    import {foowwLocalStorage} from '../rest'
    export default {
        name: 'tds',
        data() {
            return {
                search: '',
                tdsdata: [],
                selectedpkgs: [] ,//已选包的id集合
                relation:[],
                user:[],
                OldTSID:[],
                OldPKID:[],
                OldGid:[],
                lZheKouPrice:0,
                LYingFuPrice:0,
                monoidalprice:0, //单选基表2折扣价
                pkgs:[],
                disabledPackId:[],
                ft2:[],
      
            }
        },
        created(){
                 //页面加载前执行
           if (this.user.length == 0) {
              this.user=JSON.parse(foowwLocalStorage.get('user'));
            }
            console.log(this.user);
           
            this.ft2= JSON.parse(foowwLocalStorage.get('ft2'));//获取所有基表2项目
            console.log(this.ft2);
        },
        mounted() {
            
            this.getrelations();
            this.fetchData();
           
             
           
            
            
        },
        methods: {
            expandChange(row,index,e){
            this.$refs.refTable.toggleRowExpansion(row)
            },
            fetchData() {
                 let sex='10';
                if(this.user.Sex=='男')
                sex='01';
                console.log(this.user.Sex);
                this.$http.get(restbase()+"pepkg_new", {params:{gender:sex}})
                .then(response=>{
                    const d = response.data.data;
                     console.log(d);
                    this.pkgs=d;
                    this.tdsdata = [];
                    
                    d.forEach(e => {
                    var price=0;
                     e.GIDs.forEach(i=>{
                        if(this.getG(i)==undefined)
                        {
                          console.log(i);
                         }
                         
                     price+=this.getG(i).GPrice;
                     })    
                    this.tdsdata.push({name:e.PackName, PKID:e.PKID,desc:e.PKRemark,gids:e.GIDs,price:price,TSCategory
:e.TSCategory
});

                    });
                   
                  
                }, response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
            },
            getrelations(){
            //互斥关联表
            this.$http.get(restbase()+"Relation", {params:{i:1}})
                .then(response=>{
                    
                    const d = response.data.data;
                     sessionStorage.setItem('relation',JSON.stringify(d));

                }, response=>{
                    
                    console.error(response);
                })
                .catch(response=>{
                    // eslint-disable-next-line
                    console.error(response);
                })
            }, 
           
            nextstep() {
               // debugger;
                let selectedpkgs  = this.getselectedpkgs();
                
                sessionStorage.setItem('selectedpkgs',JSON.stringify(selectedpkgs));
                sessionStorage.setItem('lZheKouPrice',JSON.stringify(this.lZheKouPrice));
                const PKIDs = selectedpkgs.map(item => item.PKID);
                sessionStorage.setItem('PKIDS',JSON.stringify(PKIDs));
               
                 if(PKIDs.length>0 && PKIDs.indexOf(31)<0){
                 this.$alert('抱歉，请勾选基础套餐！', '错误', {
                        customClass:"msgBox",
                        confirmButtonText: '确定'
                         });
                 return;
                    
                }else{
                     this.$http.post(restbase() + "asp/SetTSPKTarget_new", {
                    SFZH: this.user.PaperValue,
                    TargetIDs: PKIDs,
                     type:1
                }).then((response) => {
                    this.$router.push('Monoidal');
                    console.log(response);
                }, (response) => {
                    console.log(response);
                }).catch((response) => {
                    console.log(response);
                });
                    
                }
                
            },
            hasselected() {
				return  Object.keys(this.selectedpkgs).filter(key=>this.selectedpkgs[key]).length==0 || (Object.keys(this.selectedpkgs).filter(key=>this.selectedpkgs[key]).length > 0 && this.selectedpkgs[31]);
				//return Object.keys(this.selectedpkgs).filter(key=>this.selectedpkgs[key]).length > 0;	//要求全局至少选择一个套餐
           },
            handleScroll (e) {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        
        var content= document.getElementById("content");
        if(content!=undefined){
        if(scrollTop > 223+48){
        
        content.className="contentDown";
        }else{
        content.className="contentDiv";
        }
        }

            },
          
            getG(GID) {
                return this.ft2.find(v=>{
                    return v.Gid === GID;
                });
            },
            CountPrice(pkid){
               console.log(this.selectedpkgs[pkid]);
                 var ischecked=this.selectedpkgs[pkid]
                  if(pkid==31 && !ischecked){
                    this.$alert('基础项目是体检指标中必不可少的组成部分，如您有其他原因需要取消，请您咨询客户经理或点击“确定”按钮。', '专业提示', {
                        customClass:"msgBox",
                        confirmButtonText: '确定'
                         });
                    
                }
                  if(pkid==12 && ischecked){
                    this.$alert('您选择的目标疾病中含餐后2小时血糖，需要您采血2次，如无问题，请您继续定制。', '专业提示', {
                        confirmButtonText: '确定'
                         });
                    
                }
                if((pkid==11 || pkid==10)  && ischecked){
                    this.$alert('您选择的目标疾病中含24小时管家产品，需要您同时预约时间，佩戴设备后24小时返还，如无问题，请您继续定制。', '专业提示', {
                        confirmButtonText: '确定'
                         });
                    
                }
                 if(ischecked){
                 this.$set(this.selectedpkgs,pkid,true);
                 }else
                 {
                  this.$set(this.selectedpkgs,pkid,false);
                 }
                 //如果取消基础包，其他包也被取消
                  const PKIDS = Object.keys(this.selectedpkgs).filter(key=>this.selectedpkgs[key]);
                   if(pkid==31 && !ischecked){
                   for (var i = 0; i < PKIDS.length; i++) 
                   {  
                    this.$set(this.selectedpkgs,PKIDS[i],false);
                   } 
                  }
                  //如果勾选了其他包，基础包自动被勾选
                  if(pkid!=31 && ischecked && PKIDS.indexOf(31)<=0)
                  {
                    this.$set(this.selectedpkgs,31,true);
                  }
                   //计算价格
                 
                 this.lZheKouPrice=this.CountItemPrice();
                 console.log(this.lZheKouPrice);
                 this.LYingFuPrice=Math.max(Number(this.lZheKouPrice) - Number(this.user.FixedQuota)+Number(this.user.FuWuFei),0);
                 sessionStorage.setItem('lZheKouPrice',JSON.stringify(this.lZheKouPrice));

             },
             getselectedpkgs() {
                //对象转数组并过滤出已点选的key
                const ar = Object.keys(this.selectedpkgs).filter(key=>this.selectedpkgs[key]);
                //sessionStorage.setItem('PKIDS',JSON.stringify(ar));
                
                 
                return ar.map(v=>
                    this.pkgs.find(p=>
                        String(p.PKID) === v
                    )
                );
                
            },
            CountItemPrice(){
               let itemlist = [];
               let electedpkgs2;
               let DPrice=0;
               electedpkgs2= this.getselectedpkgs();
              
               sessionStorage.setItem('electedpkgs2',JSON.stringify(electedpkgs2));
               electedpkgs2.forEach(pkg => {
                pkg.GIDs.forEach(g => {
                      if (itemlist.indexOf(g) === -1) {
                        itemlist.push(g)
                    }
                    if(itemlist.indexOf(540)>0 && itemlist.indexOf(150)>0){
                    itemlist.splice(itemlist.findIndex(item => item === 150), 1);
                }
                  if(itemlist.indexOf(540)>0 && itemlist.indexOf(149)>0){
                    itemlist.splice(itemlist.findIndex(item => item === 149), 1);
                }
                if(itemlist.indexOf(540)>0 && itemlist.indexOf(287)>0){
                   itemlist.splice(itemlist.findIndex(item => item === 287), 1);
                }
                 if(itemlist.indexOf(149)>0 && itemlist.indexOf(150)>0){
                    itemlist.splice(itemlist.findIndex(item => item === 150), 1);
                }
                 if(itemlist.indexOf(149)>0 && itemlist.indexOf(287)>0){
                    itemlist.splice(itemlist.findIndex(item => item === 287), 1);
                }
                if(itemlist.indexOf(558)>0 && itemlist.indexOf(560)>0){
                    itemlist.splice(itemlist.findIndex(item => item === 558), 1);
                }
                   if(itemlist.indexOf(559)>0 && itemlist.indexOf(560)>0){
                    itemlist.splice(itemlist.findIndex(item => item === 559), 1);
                }
                   if(itemlist.indexOf(82)>0 && itemlist.indexOf(79)>0){
                    itemlist.splice(itemlist.findIndex(item => item === 82), 1);
                }
                //特殊处理CT,不参与折扣
                 if(itemlist.indexOf(540)>=0){
                    DPrice= this.getG(540).GPrice;
                }
                    
                });
            });
           
           
                const s = itemlist.reduce((prev, item) => this.getG(item).GPrice + prev, 0)-DPrice;
                
                return s * this.user.Discount+DPrice;
                
           },
            displayChecked(PKID){
              
               let a=false;
               if(sessionStorage.getItem('PKIDS')!=undefined){

                let PKIDS=JSON.parse(sessionStorage.getItem('PKIDS'));
             
               for (var i = 0; i < PKIDS.length; i++) 
               {  
                if(PKID==PKIDS[i])
                {
                      console.log(PKID);
                    a= true;
                }
               } 
                 if(PKID==31)
                 {
                a= true;
                }
               }else{
                if(PKID==31)
                {
               a= true;
                }
               }
              this.lZheKouPrice=this.CountItemPrice();
              this.LYingFuPrice=Math.max(Number(this.lZheKouPrice) - Number(this.user.FixedQuota)+Number(this.user.FuWuFei),0);
              return a;
           },
             disabledChecked(PKID){
              /* let a=false;
                 if(PKID==31){
                  a= true;
                   }
               return a; */
           },
        }
    }
</script>

<style>
  .msgBox{
  width: 60%;
  }
    .tdsframe {
        margin:0 auto;
        width:100%;
        padding-bottom:26px;
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
        border-radius: 4px;
        box-shadow: 2px 2px 2px #888;
        background-color: white;
        margin-bottom: 10px;
    }
    .tdshead {
        width:100%;
        height:48px;
        line-height:48px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
    }
    .tdstree {
        padding:  1% 1%  1%  1%;
    }
     .tdstop {
        width:100%;
        height:48px;
        line-height:48px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
       
    }     
     .contentDown {
        font-size: 14px;
        bottom:0px;
        overflow:visible;
        position:fixed;
        z-index: 999;
        text-align:center;
        overflow:hidden;
        width:100%;
     
        line-height:35px;
        padding:0;
        color:white;
        background-color:#99a9bf;
        
    }
  

  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 80px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
   .el-table .warning-row{
    background: #f0f9eb;;
  }

</style>
